import { FC } from "react";

import { Icon } from "../../../general";

import { ChatbotClassMap } from "../types";

interface Props {
  readonly styles: ChatbotClassMap;
  readonly isVisible: boolean;
  readonly isDragging: boolean;
}

/** File upload drop target overlay with an accessible drag status announcement. */
export const FileDropZone: FC<Props> = ({ styles, isVisible, isDragging }) => (
  <>
    {!!isVisible && (
      <div className={styles.FileDropZone} aria-hidden="true" data-testid="upload-target">
        <Icon name="upload" size="large" aria-hidden="true" />
        <span className={styles.FileDropZoneText}>Drop your files here</span>
      </div>
    )}
    <span className={styles.FileDropZoneStatus} role="status" aria-live="polite">
      {isDragging ? "Drop your files here" : ""}
    </span>
  </>
);
